import {
  serializeMainGenreValue,
  deserializeMainGenreValue,
  serializeSubGenreValue,
  deserializeSubGenreValue,
} from './utils';

export type TUrlQueryKey =
  | 'genre_source'
  | 'genre_main_genres'
  | 'genre_sub_genres'
  | 'granularity'
  | 'start_date'
  | 'end_date'
  | 'region'
  | 'gsd_publisher_shared';

export const FILTER_URL_CONFIG: Record<TUrlQueryKey, IFilterUrlConfigItem<TUrlQueryKey>> = {
  genre_source: {
    inputPath: 'genretor/source',
    input: 'string',
    output: '',
    outputPath: '',
  },
  genre_main_genres: {
    inputPath: 'genretor/mainGenres',
    input: 'objectArray',
    output: '',
    outputPath: '',
    // @ts-ignore
    serializeValue: serializeMainGenreValue,
    // @ts-ignore
    deserializeValue: deserializeMainGenreValue,
  },
  genre_sub_genres: {
    inputPath: 'genretor/subGenres',
    input: 'objectArray',
    output: '',
    outputPath: '',
    // @ts-ignore
    serializeValue: serializeSubGenreValue,
    // @ts-ignore
    deserializeValue: deserializeSubGenreValue,
  },
  granularity: {
    inputPath: 'rangeTime/type',
    input: 'string',
    output: 'granularityString',
    outputPath: 'granularity',
  },
  // 注意input的类型为moment，需要指定时间粒度，也就是outputConditionKey，同时还需要有一个默认粒度defaultGranularity
  start_date: {
    inputPath: 'rangeTime/value/0',
    input: 'startDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'start_date',
    outputConditionKey: 'granularity',
  },
  end_date: {
    inputPath: 'rangeTime/value/1',
    input: 'endDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'end_date',
    outputConditionKey: 'granularity',
  },
  region: {
    inputPath: 'region/markets',
    input: 'array',
    output: 'array',
    outputPath: 'markets',
  },
  gsd_publisher_shared: {
    inputPath: 'publisher/value',
    input: 'string',
    output: 'array',
    outputPath: 'metric_condition/gsd/gsd_types',
  },
};
